import ProfilePage from './ProfilePage';
export * from './ProfilePage';
export default ProfilePage;
